import { forwardRef, createElement } from 'react';

function IconEntryTypeJournalEntry(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10.275 17.75c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zM14.25 3c.966 0 1.75.784 1.75 1.75V9c-.516 0-1.018.026-1.5.074V5.5h-11v10.75a.25.25 0 00.193.243l.057.007H9V18H3.75A1.75 1.75 0 012 16.25V4.75C2 3.784 2.784 3 3.75 3h10.5zm-3.975 11.75c.702.931 2.675 1.627 5.072 1.735l.378.012.275.003.356-.005c2.53-.061 4.638-.776 5.37-1.745.178.236.274.489.274.75 0 1.38-2.686 2.5-6 2.5s-6-1.12-6-2.5c0-.261.096-.514.275-.75zM16 10c3.314 0 6 1.12 6 2.5S19.314 15 16 15s-6-1.12-6-2.5 2.686-2.5 6-2.5zm-8.25 3a.75.75 0 110 1.5h-1.5a.75.75 0 110-1.5h1.5zM16 11.5c-1.425 0-2.742.232-3.666.617a3.354 3.354 0 00-.65.347l-.048.036.048.036c.126.091.292.186.493.278l.157.07c.924.384 2.24.616 3.666.616 1.425 0 2.742-.232 3.666-.617.273-.114.492-.233.65-.347l.047-.037-.047-.035a3.044 3.044 0 00-.493-.278l-.157-.07c-.924-.384-2.24-.616-3.666-.616zM8.25 10a.75.75 0 110 1.5h-2a.75.75 0 110-1.5h2zm3.5-3a.75.75 0 110 1.5h-5.5a.75.75 0 010-1.5h5.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var EntryTypeJournalEntry = /*#__PURE__*/forwardRef(IconEntryTypeJournalEntry);

export default EntryTypeJournalEntry;
//# sourceMappingURL=EntryTypeJournalEntry.js.map
